module.exports = __webpack_public_path__ + "static/media/test_basic_headers.a2339f18.csv";